import React, { useState, useEffect } from 'react'
import { View, useWindowDimensions, StyleSheet, Text, TouchableOpacity, Image, Dimensions, ScrollView, StatusBar, Platform } from 'react-native'
import { TabView, SceneMap, TabBar } from 'react-native-tab-view'
import BenefitsList from './benefitsList'
import BenefitsHistoryList from './benefitsHistoryList'
import styles from './benefitsTabsStyles'
import styles3 from './benefitsHomeStyles3'
import theme from '../../../theme'
import { LinealTabs, RoundedTabs } from '../customUtils/LinealTabs'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { LinearGradient } from 'expo-linear-gradient'
import { UserAvatarMobile, UserAvatarWeb } from '../web/UserAvatarWeb'
import { BenefitMainColor, BenefitTheme } from '../../../themeConstants'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'
const isWeb = Platform.OS === 'web'

const Benefits = ({ points }) => (
    <View style={styles.container}>
        <BenefitsList points={points ? points : 0} />
    </View>
)

const Redimes = ({ dataRedeems }) => (
    <>
        <View style={styles.redimesModule}>
            <BenefitsHistoryList dataRedeems={dataRedeems} />
        </View>
    </>
)
const BenefitCard = ({ points }) => {
    const { languageFile } = getLanguage()
    //console.log('🚀 ~ BenefitCard ~ points:', points)
    const gradient = theme.colors.colorPrimary + '14'

    return (
        <View
            style={[
                styles3.container,
                {
                    borderRadius: 12,
                    overflow: 'hidden',
                    marginHorizontal: 0,
                    maxWidth: 1024,
                    marginTop: 4,
                    alignContent: 'center',
                    alignItems: 'center',
                    backgroundColor: gradient,
                },
            ]}
        >
            <View style={[styles3.feedbackAssetContainer]}>
                {!isWeb ? (
                    <UserAvatarMobile
                        style={{
                            width: 56,
                            flex: 1,
                            aspectRatio: 1,
                            borderRadius: 28,
                        }}
                    />
                ) : (
                    <UserAvatarWeb
                        style={{
                            width: 56,
                            flex: 1,
                            aspectRatio: 1,
                            borderRadius: 28,
                        }}
                        avatarUrl={''}
                    />
                )}
            </View>

            <View style={[styles3.levelKnowledgeBlock]}>
                <View>
                    <View style={[styles3.containerDataBaseline, { alignItems: undefined }]}>
                        <Text style={[styles3.value, { color: theme.colors.colorPrimary, fontSize: 16, fontWeight: '700', marginTop: 0 }]}>
                            {points + ' puntos'}
                        </Text>
                    </View>

                    <Text style={[styles3.subtitle, { fontSize: 16, color: theme.colors.darkGray, marginTop: 4 }]}>{'Tus puntos acumulados'}</Text>
                </View>
            </View>
        </View>
    )
}

export default function BenefitsTabs({ dataRedeems, points }) {
    const [selectedIndex, setSelectedIndex] = React.useState(0)

    const isMobile = useIsMobile()

    const [tabs, setTabs] = React.useState([])

    const { languageFile } = getLanguage()

    useEffect(() => {
        setTabs([
            {
                name: languageFile.benefits_mayus,
                index: 0,
            },
            {
                name: languageFile.history,
                index: 1,
            },
        ])
    }, [])
    return (
        <View style={[{ flex: 1 }, { marginHorizontal: 12 }]}>
            <RoundedTabs
                tabs={tabs}
                selectedIndex={selectedIndex}
                colorLGStart={BenefitTheme.benefitGradient[0]}
                colorLGEnd={BenefitTheme.benefitGradient[1]}
                colorSelected={BenefitTheme.tabsSelectedColor}
                colorUnselected={BenefitTheme.tabsUnselectedColor}
                color={theme.colors.darkGray}
                onSelectedTab={(index) => {
                    setSelectedIndex(index)
                }}
                containerStyle={{ marginHorizontal: 0 }}
                textColorOn={BenefitMainColor}
                textColorOff={theme.colors.textPrimary}
            />
            <BenefitCard points={points ? points : 0} />
            {(() => {
                switch (selectedIndex) {
                    case 0:
                        return <Benefits points={points ? points : 0} />
                    case 1:
                        return <Redimes dataRedeems={dataRedeems} />
                    default:
                        return <Text>{languageFile.there_was_a_mistake}</Text>
                }
            })()}
        </View>
    )
}
